export const equipmentStatusTranslation = {
  enabled: 'Ativo',
  blocked: 'Bloqueado',
  disabled: 'Inativo',
  awaiting_card: 'Aguardando cartão'
}
